var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.762,
    height: 22.758,
    viewBox: "0 0 22.762 22.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1.081-511.718a1.741,1.741,0,0,0-1,.987A5.455,5.455,0,0,0,0-509.042c0,1.619.009,1.694.3,2.085.071.1,1.89,1.788,4.042,3.758,3.455,3.162,3.922,3.611,4.042,3.833l.133.258.022,4.829c.022,4.558.027,4.834.1,4.949a.678.678,0,0,0,.618.3h.258l2.054-1.37c2.13-1.423,2.352-1.6,2.539-2,.1-.2.1-.245.12-3.46l.022-3.246.133-.258c.116-.222.591-.671,4.047-3.837,2.152-1.97,3.98-3.673,4.06-3.789.267-.374.28-.5.267-2.148l-.013-1.481-.12-.245a1.887,1.887,0,0,0-.792-.792l-.245-.12-10.138-.009C1.81-511.794,1.3-511.794,1.081-511.718Z",
    transform: "translate(0 511.789)",
    fill: "#2a2a2a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.719a662079fd65a1f27f12e4abdeff3e.svg";
export { ForwardRef as ReactComponent };